export default __webpack_public_path__ + "static/media/source-logo-bigquery.55eb5fea.png";